var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "chatchamp", class: _vm.classes }, [
    _c(
      "div",
      { class: _vm.containerClasses, style: _vm.cssVariableStyles },
      [
        _vm.isLoading
          ? _c("loading-indicator")
          : [
              _c(
                "transition",
                {
                  attrs: { name: "trbo-a-slide-to-up", css: !_vm.isEmbedded },
                  on: { "after-enter": _vm.enableParentsTransformMobile },
                },
                [
                  _vm.isLandingPage
                    ? _c(
                        "resize-observer",
                        {
                          staticClass:
                            "trbo-a-chatchamp-wizard-container__landing-page",
                          on: { "update-height": _vm.setLandingPageHeight },
                        },
                        [_c("landing-page")],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                {
                  attrs: {
                    name: "trbo-a-slide-from-down",
                    css: !_vm.isEmbedded,
                  },
                  on: {
                    "before-leave": _vm.setWizardPageHeight,
                    "before-enter": _vm.disableParentsTransformMobile,
                    "after-enter": _vm.setAutoHeight,
                  },
                },
                [
                  !_vm.isLandingPage
                    ? _c(
                        "resize-observer",
                        {
                          ref: "wizardPagesContainer",
                          staticClass:
                            "trbo-a-chatchamp-wizard-container__questions-page",
                          on: {
                            "update-height": _vm.setWizardPagesHeight,
                            scroll: _vm.onScroll,
                          },
                        },
                        [
                          _c("wizard-pages", {
                            on: { navigate: _vm.onNavigate },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }